@switch (treatmentType) {
  @case (ConsultationTreatmentTypes.Trt) {
    <app-alleviate-nausea-and-vomiting-trt />
  }
  @case (ConsultationTreatmentTypes.TrtRenewal) {
    <app-alleviate-nausea-and-vomiting-trt />
  }
  @case (ConsultationTreatmentTypes.Peptide) {
    <app-alleviate-nausea-and-vomiting-peptide />
  }
  @case (ConsultationTreatmentTypes.PeptideRenewal) {
    <app-alleviate-nausea-and-vomiting-peptide />
  }
  @default {
    <app-alleviate-nausea-and-vomiting />
  }
}
